var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1.5 1.5)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_2805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.1216,
    y: 19.1216,
    width: 11.2434,
    height: 11.2434,
    transform: "rotate(-180 19.1216 19.1216)",
    fill: "#9C6EC4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 19.2139,
    width: 8.08122,
    height: 8.08122,
    transform: "rotate(-135 13.5 19.2139)",
    fill: "#B894DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.9326L7.87828 19.1217L19.1217 19.1217L13.5 21.9326Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1216 7.87792V6.19141L20.8081 7.87792L19.1216 7.87792Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87842 7.87792V6.19141L6.1919 7.87792L7.87842 7.87792Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1216 19.1216V20.8081L20.8081 19.1216H19.1216Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87841 19.1216V20.8081L6.1919 19.1216H7.87841Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06756 13.4997L7.87842 7.87793L7.87842 19.1214L5.06756 13.4997Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.06721L7.87828 7.87807L19.1217 7.87807L13.5 5.06721Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9329 13.4997L19.1221 7.87793L19.1221 19.1214L21.9329 13.4997Z",
    fill: "#A166D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4298 13.4997L20.8081 7.87797L19.1215 7.87797L21.9324 13.4997L26.4298 13.4997Z",
    fill: "#C7A3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 26.4295L19.1217 20.8078L19.1217 19.1213L13.5 21.9321L13.5001 26.4295Z",
    fill: "#C7A3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.57017 13.4997L6.19194 7.87797L7.87845 7.87797L5.0676 13.4997L0.57017 13.4997Z",
    fill: "#C7A3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.569824L19.1217 6.1916L19.1217 7.87811L13.5 5.06725L13.5 0.569824Z",
    fill: "#C7A3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4299 13.4997L20.8081 19.1214L19.1216 19.1214L21.9325 13.4997L26.4299 13.4997Z",
    fill: "#B080DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 26.4295L7.87826 20.8078L7.87826 19.1213L13.5 21.9321L13.4999 26.4295Z",
    fill: "#B080DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.570117 13.4997L6.19189 19.1214L7.8784 19.1214L5.06755 13.4997L0.570117 13.4997Z",
    fill: "#B080DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.569824L7.87831 6.1916L7.87831 7.87811L13.5 5.06725L13.5 0.569824Z",
    fill: "#B080DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_2805"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 0.569824,
    width: 18.2858,
    height: 18.2857,
    rx: 2.28571,
    transform: "rotate(45 13.5 0.569824)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple);
export default __webpack_public_path__ + "static/media/purple.c01043ac87e0d41b7827e00a0d999fc7.svg";
export { ForwardRef as ReactComponent };